import { lazy } from 'react';

const ProjectForecastPage = lazy(() => import('./ProjectForecastPage'));

const ProjectForecastConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: 'projectForecast',
            element: <ProjectForecastPage />,
        },
    ],
};

export default ProjectForecastConfig;